/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RuleSetCustomizationSyncResponseDto
 */
export interface RuleSetCustomizationSyncResponseDto {
    /**
     * 
     * @type {number}
     * @memberof RuleSetCustomizationSyncResponseDto
     */
    customizationCount: number;
}

/**
 * Check if a given object implements the RuleSetCustomizationSyncResponseDto interface.
 */
export function instanceOfRuleSetCustomizationSyncResponseDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "customizationCount" in value;

    return isInstance;
}

export function RuleSetCustomizationSyncResponseDtoFromJSON(json: any): RuleSetCustomizationSyncResponseDto {
    return RuleSetCustomizationSyncResponseDtoFromJSONTyped(json, false);
}

export function RuleSetCustomizationSyncResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): RuleSetCustomizationSyncResponseDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'customizationCount': json['customizationCount'],
    };
}

export function RuleSetCustomizationSyncResponseDtoToJSON(value?: RuleSetCustomizationSyncResponseDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'customizationCount': value.customizationCount,
    };
}

